import service from '@/store/services/notification-service';

const state = {
  list: {},
  notification: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, notification) => {
    state.notification = notification;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  

  markNotification({commit, dispatch}, params) {
    
    return service.markNotification(params);
  },


  // destroy({commit, dispatch}, params) {
  //   return service.destroy(params);
  // }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  notification: state => state.notification,
};
 
const notification = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default notification;
